import { authApiCall } from '../auth/saga';

export const getDashboardData = params =>
  authApiCall({
    url: '/dashboards/business-chart-dashboard/',
    method: 'get',
    params,
  });
